import React from "react";
import PropTypes from "prop-types";

import { IoAdd } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function SupportResourcesAddButton({
  id,
  items,
  addItem,
  disabled,
  isNightMode
}) {
  return (
    <span
      style={{
        margin: 0,
        marginLeft: "auto",
        justifySelf: "flex-end",
        height: "20px"
      }}
    >
      <button
        id={`${id}-add-icon-btn`}
        className="icon-btn"
        type="button"
        onClick={addItem}
        disabled={items.some((item) => !item.employee) || disabled}
        data-tooltip-variant={isNightMode ? "dark" : "light"}
      >
        <IoAdd size={24} />
      </button>
      <ReactTooltip
        id={`${id}-add-icon-btn`}
        place="left"
        anchorId={`${id}-add-icon-btn`}
        className={`custom-tooltip ${isNightMode ? "dark" : "light"}`}
      >
        Add Support Resource
      </ReactTooltip>
    </span>
  );
}

SupportResourcesAddButton.propTypes = {
  id: PropTypes.string,
  items: PropTypes.array,
  isNightMode: PropTypes.bool,
  disabled: PropTypes.bool,
  addItem: PropTypes.func
};
